<template>
  <div id="battle">
    <transition name="fade" mode="out-in">
      <div
        class="loading"
        style="height: 100vh; background: orange"
        v-if="loading"
        key="loading"
      >
        <pulse-loader
          color="#ffffff"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -28.5px;
            margin-top: -12px;
          "
        ></pulse-loader>
      </div>
      <div v-else-if="line_error">
        <error-page></error-page>
      </div>
      <div v-else key="cotent" style="overflow-x: hidden">
        <div
          style="
            background: white;
            max-width: 380px;
            width: 100%;
            margin: auto;
            border: 1px solid #eee;
          "
        >
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="out-in"
          >
            <div v-if="state == 'welcome'" key="welcome">
              <img
                :src="'./img/battle/welcome_game.png'"
                alt=""
                style="width: 100%"
              />
              <div
                class="text-center"
                style="position: relative; background: #ffdb91"
              >
                <div
                  style="width: 100%; padding-top: 45px; padding-bottom: 45px"
                >
                  <a
                    href="javascript:void(0);"
                    class="btn btn-blue btn-lg"
                    style="width: 220px"
                    @click="onSelectSingleplayer"
                    ><img
                      :src="'./img/battle/singleplayer_icon.png'"
                      alt=""
                      style="width: 50px"
                    />
                    Single Player</a
                  >
                  <br />
                  <br />
                  <a
                    href="javascript:void(0);"
                    class="btn btn-blue btn-lg"
                    style="width: 220px"
                    disabled="disabled"
                    ><img
                      :src="'./img/battle/multiplayer_icon.png'"
                      alt=""
                      style="width: 50px"
                    />
                    Multi Player</a
                  ><br />
                  <br />
                  <a
                    href="javascript:void(0);"
                    class="btn btn-blue btn-lg"
                    style="width: 220px"
                    @click="onLeaderboard"
                    ><img
                      :src="'./img/battle/leaderboard_icon.png'"
                      alt=""
                      style="width: 50px"
                    />
                    Leaderboard</a
                  >
                </div>
              </div>
            </div>
            <div
              v-if="state == 'singleplayer'"
              key="singleplayer"
              style="min-height: 100vh"
            >
              <div
                v-if="loadingOpponent"
                style="height: 100vh; background: white; position: relative"
              >
                <pulse-loader
                  color="orange"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -28.5px;
                    margin-top: -12px;
                  "
                ></pulse-loader>
              </div>
              <template v-else>
                <div class="container-fluid">
                  <div class="row" style="margin-top: 15px">
                    <div class="col-xs-2 text-center">
                      <a
                        href="javascript:void(0);"
                        style="font-size: 32px"
                        @click="state = 'welcome'"
                        ><span class="glyphicon glyphicon-chevron-left"></span
                      ></a>
                    </div>
                    <div class="col-xs-6 text-right">
                      <div
                        style="
                          background: #eee;
                          padding: 10px 15px 5px 15px;
                          border: 1px solid #eee;
                          border-radius: 30px;
                          font-size: 15px;
                          position: relative;
                        "
                      >
                        <img
                          :src="'./img/battle/medal_icon.png'"
                          alt=""
                          style="
                            width: 55px;
                            position: absolute;
                            left: 0;
                            margin-left: -27.5px;
                            top: 50%;
                            margin-top: -27.5px;
                          "
                        /><span>{{ rank | numberFormat }}</span>
                      </div>
                    </div>
                    <div class="col-xs-4 text-right">
                      <div
                        style="
                          background: #eee;
                          padding: 10px 15px 5px 15px;
                          border: 1px solid #eee;
                          border-radius: 30px;
                          font-size: 15px;
                          position: relative;
                        "
                      >
                        <img
                          :src="'./img/battle/battery_icon.png'"
                          alt=""
                          style="
                            width: 55px;
                            position: absolute;
                            left: 0;
                            margin-left: -27.5px;
                            top: 50%;
                            margin-top: -27.5px;
                          "
                        /><span>{{ 5 - player.today_gamerank }}/5</span>
                      </div>
                    </div>
                  </div>
                </div>
                <h3 class="text-center" style="color: #ffa500">
                  Select opponent
                </h3>
                <div
                  v-if="5 - player.today_gamerank <= 0"
                  class="text-center"
                  style="
                    background: #f58080;
                    border-radius: 40px;
                    color: white;
                    padding: 10px 0px 2px 0px;
                    margin: 0px 15px;
                  "
                >
                  <p class="small">Not enough energy for today</p>
                </div>
                <div
                  v-if="opponents && opponents.length > 0"
                  style="margin-top: 35px"
                >
                  <ul class="opponent-list">
                    <li
                      v-for="(opponent_player, index) in opponents"
                      :key="'player_' + index"
                      @click="startBattle(opponent_player)"
                      :class="{ disable: 5 - player.today_gamerank <= 0 }"
                    >
                      <div class="player-image-container">
                        <div class="tuinui-image">
                          <img
                            :src="
                              './img/tuinui/mon_' +
                              opponent_player.current_tuinui_id +
                              '.png'
                            "
                            alt=""
                          />
                        </div>
                        <img
                          :src="opponent_player.profile_pic"
                          v-if="opponent_player.profile_pic"
                          alt=""
                          class="player-image"
                        />
                      </div>
                      <div style="float: left; padding: 5px 15px">
                        <h4 style="color: #ffa500">
                          ตุ้ยนุ้ย{{
                            opponent_player.current_tuinui_id | getTuinui
                          }}
                        </h4>
                        <p class="small" style="color: #c3c3c3">
                          ของ {{ opponent_player.first_name | truncate(15) }}
                        </p>
                        <strong style="margin-right: 5px">Lv</strong
                        >{{ opponent_player.current_level }}<br />
                        <strong style="margin-right: 5px">Rank</strong
                        ><span>{{
                          opponent_player.current_gamerank | numberFormat
                        }}</span>
                      </div>

                      <div class="clearfix"></div>
                    </li>
                  </ul>
                </div>
                <div v-else style="margin-top: 35px">
                  <ul class="opponent-list">
                    <li
                      @click="startBattle(dummy)"
                      :class="{ disable: 5 - player.today_gamerank <= 0 }"
                    >
                      <div class="player-image-container">
                        <div class="tuinui-image">
                          <img
                            :src="
                              './img/tuinui/mon_' +
                              dummy.current_tuinui_id +
                              '.png'
                            "
                            alt=""
                          />
                        </div>
                        <img
                          :src="dummy.profile_pic"
                          v-if="dummy.profile_pic"
                          alt=""
                          class="player-image"
                        />
                      </div>
                      <div style="float: left; padding: 5px 15px">
                        <h4 style="color: #ffa500">
                          ตุ้ยนุ้ย{{ dummy.current_tuinui_id | getTuinui }}
                        </h4>
                        <p class="small" style="color: #c3c3c3">
                          ของ {{ dummy.first_name }}
                        </p>
                        <strong style="margin-right: 5px">Lv</strong
                        >{{ dummy.current_level }}<br />
                        <strong style="margin-right: 5px">Rank</strong
                        ><span>{{
                          dummy.current_gamerank | numberFormat
                        }}</span>
                      </div>

                      <div class="clearfix"></div>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
            <div
              v-if="state == 'battle'"
              key="battle"
              style="position: relative"
            >
              <transition enter-active-class="animated fadeIn">
                <div
                  class="overlay"
                  v-if="showResult"
                  style="
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    background: #0000005c;
                    z-index: 300;
                  "
                >
                  <div
                    class="text-center"
                    style="position: absolute; margin-top: 50px; width: 100%"
                  >
                    <div style="height: 150px">
                      <transition enter-active-class="animated tada">
                        <div v-if="showWinner">
                          <img
                            v-if="battle_result == 'player'"
                            :src="'./img/battle/win.png'"
                            alt=""
                            style="width: 280px"
                            key="win"
                          />
                          <img
                            v-else-if="battle_result == 'opponent'"
                            :src="'./img/battle/lose.png'"
                            alt=""
                            style="width: 280px"
                            key="lose"
                          />
                        </div>
                      </transition>
                    </div>
                    <transition enter-active-class="animated fadeIn">
                      <div v-if="showRank">
                        <div
                          style="
                            background: white;
                            padding: 10px;
                            margin: 15px 0;
                          "
                        >
                          <img
                            :src="
                              './img/battle/medal_' +
                              rankDirection +
                              '_icon.png'
                            "
                            style="width: 100px"
                            alt=""
                          />
                          <p style="margin: 0">Rank</p>
                          <h1
                            style="margin: 0; margin-top: 10px; color: orange"
                          >
                            {{ animatedRank }}
                          </h1>
                        </div>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-blue btn-lg"
                          @click="resetBattle"
                          ><img
                            :src="'./img/battle/mainmenu_icon.png'"
                            alt=""
                            style="width: 50px"
                          />
                          Main Menu</a
                        >
                      </div>
                    </transition>
                  </div>
                </div>
              </transition>

              <div
                class="text-center"
                :style="{ 'background-image': 'url(./img/bg_battle.png)' }"
                style="
                  min-height: 378px;
                  background-repeat: no-repeat;
                  background-size: cover;
                  background-position: center;
                  position: relative;
                "
              >
                <transition leave-active-class="animated fadeOut">
                  <div
                    v-show="showCountDown"
                    class="text-center"
                    style="
                      background: orange;
                      border-radius: 50%;
                      width: 250px;
                      height: 250px;
                      background-repeat: no-repeat;
                      background-size: cover;
                      background-position: center;
                      position: absolute;
                      left: 50%;
                      top: 50%;
                      margin-left: -125px;
                      margin-top: -125px;
                      z-index: 100;
                    "
                  >
                    <transition-group
                      enter-active-class="animated tada"
                      :duration="{ enter: 1000 }"
                    >
                      <div
                        v-show="step == 0"
                        key="step_shake"
                        style="
                          margin-top: -100px;
                          top: 50%;
                          position: absolute;
                          margin-left: -60px;
                          left: 50%;
                        "
                      >
                        <img
                          :src="'./img/battle/shake_icon.png'"
                          style="width: 120px"
                        />
                        <h3 style="margin: 0; color: white">{{ count }}</h3>
                      </div>
                      <img
                        v-show="step == 1"
                        key="step_1"
                        :src="'./img/battle/1.png'"
                        style="
                          width: 160px;
                          margin-top: -90px;
                          top: 50%;
                          position: absolute;
                          margin-left: -80px;
                        "
                      />
                      <img
                        v-show="step == 2"
                        key="step_2"
                        :src="'./img/battle/2.png'"
                        style="
                          width: 160px;
                          margin-top: -90px;
                          top: 50%;
                          position: absolute;
                          margin-left: -80px;
                        "
                      />
                      <img
                        v-show="step == 3"
                        key="step_3"
                        :src="'./img/battle/3.png'"
                        style="
                          width: 160px;
                          margin-top: -90px;
                          top: 50%;
                          position: absolute;
                          margin-left: -80px;
                        "
                      />
                    </transition-group>
                  </div>
                </transition>

                <div class="container-fluid">
                  <div class="row text-center">
                    <div
                      class="col-xs-5"
                      style="font-size: 15px; color: white; padding: 10px 0px"
                    >
                      <img
                        :src="player.profile_pic"
                        v-if="player.profile_pic"
                        alt=""
                        style="
                          width: 50px;
                          height: 50px;
                          border-radius: 50%;
                          border: 1px solid #eee;
                          background: #eee;
                          margin-bottom: 6px;
                        "
                      /><br />
                      ตุ้ยนุ้ย{{ player.current_tuinui_id | getTuinui }}
                      <div
                        v-if="showHp"
                        style="
                          border-radius: 10px;
                          overflow: hidden;
                          width: 80%;
                          height: 10px;
                          background: #eee;
                          margin: auto;
                          margin-top: 5px;
                        "
                      >
                        <div
                          style="height: 100%; background: #52f316"
                          :style="{
                            width: (player_hp * 100) / player_maxhp + '%',
                          }"
                        ></div>
                      </div>
                    </div>
                    <div class="col-xs-2" style="padding: 0">
                      <img
                        :src="'./img/battle/vs.png'"
                        alt=""
                        style="width: 100%; margin-top: 10px"
                      />
                    </div>
                    <div
                      class="col-xs-5"
                      style="font-size: 15px; color: white; padding: 10px 0px"
                    >
                      <img
                        :src="opponent.profile_pic"
                        v-if="opponent.profile_pic"
                        alt=""
                        style="
                          width: 50px;
                          height: 50px;
                          border-radius: 50%;
                          border: 1px solid #eee;
                          background: #eee;
                          margin-bottom: 6px;
                        "
                      /><br />
                      ตุ้ยนุ้ย{{ opponent.current_tuinui_id | getTuinui }}
                      <div
                        v-if="showHp"
                        style="
                          border-radius: 10px;
                          overflow: hidden;
                          width: 80%;
                          height: 10px;
                          background: #eee;
                          margin: auto;
                          margin-top: 5px;
                        "
                      >
                        <div
                          style="
                            height: 100%;
                            background: #52f316;
                            margin-left: auto;
                          "
                          :style="{
                            width: (opponent_hp * 100) / opponent_maxhp + '%',
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  id="tuinui"
                  ref="tuinui"
                  :src="'./img/tuinui/mon_' + player.current_tuinui_id + '.png'"
                  style="
                    max-width: 220px;
                    position: absolute;
                    margin-left: -110px;
                    left: 90px;
                    top: 100px;
                  "
                />
                <img
                  ref="opponent"
                  :src="
                    './img/tuinui/mon_' + opponent.current_tuinui_id + '.png'
                  "
                  style="
                    max-width: 220px;
                    position: absolute;
                    margin-left: -110px;
                    right: -30px;
                    top: 100px;
                  "
                />

                <h3
                  ref="damage_player"
                  style="
                    opacity: 0;
                    position: absolute;
                    min-width: 200px;
                    margin-left: -100px;
                    left: 90px;
                    top: 100px;
                    color: red;
                  "
                >
                  {{ damage_player }}
                </h3>
                <h3
                  ref="damage_opponent"
                  style="
                    opacity: 0;
                    position: absolute;
                    min-width: 200px;
                    margin-left: -100px;
                    right: -10px;
                    top: 100px;
                    color: red;
                  "
                >
                  {{ damage_opponent }}
                </h3>

                <img
                  ref="attack_by_player"
                  :src="'./img/battle/attack-2.png'"
                  alt=""
                  style="
                    opacity: 0;
                    width: 150px;
                    position: absolute;
                    margin-left: -75px;
                    margin-top: -75px;
                    top: 250px;
                    right: 50px;
                  "
                />
                <img
                  ref="attack_by_opponent"
                  :src="'./img/battle/attack-2.png'"
                  alt=""
                  style="
                    opacity: 0;
                    width: 150px;
                    position: absolute;
                    margin-left: -75px;
                    margin-top: -75px;
                    top: 250px;
                    left: 125px;
                  "
                />

                <div
                  v-show="isAttack"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -75px;
                    margin-top: -45px;
                  "
                >
                  <img
                    :src="'./img/battle/attack-1.gif'"
                    alt=""
                    style="width: 150px"
                  />
                </div>
              </div>

              <div style="background: whtie">
                <div style="padding: 10px">
                  <div style="background: #eee; height: 200px; overflow: auto">
                    <p style="padding: 10px" v-html="battlelog"></p>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="state == 'leaderboard'" key="leaderboard">
              <div
                v-if="loadingLeaderboard"
                style="height: 100vh; background: white; position: relative"
              >
                <pulse-loader
                  color="orange"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -28.5px;
                    margin-top: -12px;
                  "
                ></pulse-loader>
              </div>
              <template v-else>
                <div class="container-fluid">
                  <div class="row" style="margin-top: 15px">
                    <div class="col-xs-2 text-center">
                      <a
                        href="javascript:void(0);"
                        style="font-size: 32px"
                        @click="state = 'welcome'"
                        ><span class="glyphicon glyphicon-chevron-left"></span
                      ></a>
                    </div>
                    <div class="col-xs-8">
                      <h3 class="text-center" style="color: #ffa500">
                        Leaderboard
                      </h3>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <div class="row">
                    <div
                      class="col-xs-4 top-rank text-center"
                      style="margin-top: 45px"
                    >
                      <!-- <h4>2</h4> -->
                      <div style="position: relative; margin-top: 45px">
                        <img
                          :src="'./img/leaderboard/crown_2.png'"
                          alt=""
                          class="crown"
                        />
                        <div
                          class="top-rank-img"
                          style="width: 80px; height: 80px; margin: auto"
                        >
                          <img :src="leaderboard[1].profile_pic" alt="" />
                        </div>
                      </div>
                      <h5>
                        {{ leaderboard[1].first_name | truncate(10) }}
                      </h5>
                      <span class="rank">{{
                        leaderboard[1].current_gamerank | numberFormat
                      }}</span>
                    </div>
                    <div class="col-xs-4 top-rank text-center">
                      <!-- <h3>1</h3> -->
                      <div style="position: relative; margin-top: 45px">
                        <img
                          :src="'./img/leaderboard/crown_1.png'"
                          alt=""
                          class="crown"
                        />
                        <div
                          class="top-rank-img"
                          style="width: 90px; height: 90px; margin: auto"
                        >
                          <img :src="leaderboard[0].profile_pic" alt="" />
                        </div>
                      </div>
                      <h4>
                        {{ leaderboard[0].first_name | truncate(10) }}
                      </h4>
                      <span class="rank">{{
                        leaderboard[0].current_gamerank | numberFormat
                      }}</span>
                    </div>
                    <div
                      class="col-xs-4 top-rank text-center"
                      style="margin-top: 45px"
                    >
                      <!-- <h4>3</h4> -->
                      <div style="position: relative; margin-top: 45px">
                        <img
                          :src="'./img/leaderboard/crown_3.png'"
                          alt=""
                          class="crown"
                        />
                        <div
                          class="top-rank-img"
                          style="width: 80px; height: 80px; margin: auto"
                        >
                          <img :src="leaderboard[2].profile_pic" alt="" />
                        </div>
                      </div>
                      <h5>
                        {{ leaderboard[2].first_name | truncate(10) }}
                      </h5>
                      <span class="rank">{{
                        leaderboard[2].current_gamerank | numberFormat
                      }}</span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="leaderboard && leaderboard.length > 0"
                  style="margin-top: 35px"
                >
                  <ul class="leaderboard-list">
                    <li v-for="(n, index) in 97" :key="'player_' + index">
                      <div
                        :class="{
                          active:
                            userid + '__148369119115215' ==
                            leaderboard[n + 2].id,
                        }"
                      >
                        <div class="player-image-container">
                          <h3
                            style="
                              display: inline-block;
                              float: left;
                              width: 60px;
                              text-align: center;
                              color: #c3c3c3;
                            "
                          >
                            {{ n + 3 }}
                          </h3>
                          <div class="player-image">
                            <img :src="leaderboard[n + 2].profile_pic" alt="" />
                          </div>
                          <!-- <div class="tuinui-image">
                                                        <img :src="'./img/tuinui/mon_' + leaderboard[n + 2].current_tuinui_id + '.png'" alt="" >
                                                    </div> -->
                        </div>
                        <div style="float: left; padding: 10px 15px">
                          <h4>
                            {{ leaderboard[n + 2].first_name | truncate(15) }}
                          </h4>
                          <strong style="margin-right: 5px; color: orange"
                            >Rank</strong
                          ><span>{{
                            leaderboard[n + 2].current_gamerank | numberFormat
                          }}</span>
                        </div>

                        <div class="clearfix"></div>
                      </div>
                    </li>
                    <li v-if="!isInLeaderboard">
                      <div class="active">
                        <div class="player-image-container">
                          <h3
                            style="
                              display: inline-block;
                              float: left;
                              width: 60px;
                              text-align: center;
                              color: #c3c3c3;
                            "
                          >
                            -
                          </h3>
                          <div class="player-image">
                            <img :src="player.profile_pic" alt="" />
                          </div>
                        </div>
                        <div style="float: left; padding: 10px 15px">
                          <h4>{{ player.first_name | truncate(20) }}</h4>
                          <strong style="margin-right: 5px; color: orange"
                            >Rank</strong
                          ><span>{{
                            player.current_gamerank | numberFormat
                          }}</span>
                        </div>

                        <div class="clearfix"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ErrorPage from "@/views/components/ErrorPage.vue";

import $ from "jquery";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Velocity from "velocity-animate";
import numeral from "numeral";
import { TweenLite } from "gsap/TweenMax";

var Shake = require("shake.js");

export default {
  data: function () {
    return {
      battle_mode: "singleplayer",
      isBattle: false,
      isHost: false,
      roomid: null,
      multiplayercode: null,

      opponents: [],
      leaderboard: [],

      opponent: null,
      player: null,

      energy: 0,

      userid: "null", //U15dcdd6825d0efae99fb8f144ed7cfd1
      duration: false,
      loading: true,
      loadingOpponent: true,
      loadingLeaderboard: true,
      count: 0,
      state: "welcome",
      step: null,
      battle_result: null,
      showResult: false,
      showCountDown: false,
      showWinner: false,
      showRank: false,
      showHp: false,
      isAttack: false,

      tweenedRank: 0,
      rank: null,
      rankDirection: "up", // 'down'

      shake_time: 10000,

      images: [],
      battlelog: "",
      line_error: false,

      damage_player: 0,
      damage_opponent: 0,
      isInLeaderboard: false,

      player_hp: 0,
      opponent_hp: 0,

      player_maxhp: 0,
      opponent_maxhp: 0,
    };
  },
  components: {
    PulseLoader,
    ErrorPage,
  },
  computed: {
    dummy: function () {
      var vm = this;
      return {
        id: "dummy",
        profile_pic: "./img/battle/profile.jpg",
        current_tuinui_id: vm.player.current_tuinui_id,
        first_name: "ตุ้ยนุ้ยราชา",
        current_level: vm.player.current_level,
        current_gamerank: vm.rank,
      };
    },
    animatedRank: function () {
      return numeral(this.tweenedRank).format("0,0");
    },
  },
  mounted: async function () {
    this.loading = true;

    try {
      await this.$liff.init({
        liffId: process.env.VUE_APP_LIFF_ID_BATTLE, // Use own liffId
      });
      if (this.$liff.isLoggedIn()) {
        const profile = await this.$liff.getProfile();
        this.display_name = profile.displayName;
        this.userid = profile.userId;

        await this.getPlayerInfo();
        this.loading = false;
      } else this.$liff.login();
    } catch (error) {
      this.line_error = true;
    }
    this.loading = false;
  },
  methods: {
    onLeaderboard: function () {
      var vm = this;
      vm.state = "leaderboard";
      vm.loadingLeaderboard = true;
      vm.getLeaderboard(function () {
        vm.loadingLeaderboard = false;
      });
    },
    onSelectSingleplayer: function () {
      var vm = this;
      vm.battle_mode = "singleplayer";
      vm.state = "singleplayer";
      vm.loadingOpponent = true;
      vm.getOpponentList(function () {
        vm.loadingOpponent = false;
      });
    },
    startBattle: function (opponent) {
      var vm = this;

      if (5 - vm.player.today_gamerank <= 0 || vm.isBattle == true) {
        return false;
      }
      vm.opponent = opponent;
      vm.showCountDown = true;
      vm.isBattle = true;

      setTimeout(() => {
        vm.state = "battle";
        var count = 3;
        setTimeout(() => {
          // vm.$nextTick(function () {
          //     Velocity(vm.$refs.tuinui, { width: '240px' , height: '200px' }, {loop: true})
          //     Velocity(vm.$refs.opponent, { width: '240px' , height: '200px' }, {loop: true})
          // })
          var timer = setInterval(function () {
            if (count == 0) {
              clearInterval(timer);
              vm.startShake();
            } else {
              vm.battlelog = count + "<br>" + vm.battlelog;
            }
            vm.step = count;
            count--;
          }, 1000);
        }, 1000);
      }, 1000);
    },
    getPlayerInfo: function () {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";

      return new Promise((resolve, reject) => {
        $.ajax({
          url:
            SERVER_URL +
            "getuserprofile?userid=" +
            vm.userid +
            "__148369119115215",
          type: "GET",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function (result) {
            if (result.responsecode == 200 && result.data != null) {
              var row = result.data[0];
              vm.player = row;
              vm.rank = vm.player.current_gamerank;

              resolve();
            } else {
              vm.line_error = true;
              resolve();
            }
          },
          error: function (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            vm.line_error = true;
            reject();
          },
        });
      });
    },
    getOpponentList: function (callback) {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      $.ajax({
        url:
          SERVER_URL +
          "getcompetitorlist?userid=" +
          vm.userid +
          "__148369119115215",
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (result) {
          if (result.responsecode == 200 && result.data != null) {
            vm.opponents = result.data;
            callback();
          }
        },
        error: function (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          callback();
        },
      });
    },
    getLeaderboard: function (callback) {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      $.ajax({
        url: SERVER_URL + "getleaderboard",
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (result) {
          if (result.responsecode == 200 && result.data != null) {
            vm.leaderboard = result.data;
            vm.isInLeaderboard = false;
            $.each(vm.leaderboard, function (index, val) {
              if (val.id == vm.userid + "__148369119115215") {
                vm.isInLeaderboard = true;
                return false;
              }
            });
            callback();
          }
        },
        error: function (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          callback();
        },
      });
    },
    calculateBattle: function (callback) {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      var data = {
        userid: vm.userid + "__148369119115215",
        shake: vm.count >= 200 ? 200 : vm.count,
        competitorid: vm.opponent.id,
      };
      $.ajax({
        url: SERVER_URL + "battle",
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(data),
        success: function (result) {
          if (result.responsecode == 200 && result.data != null) {
            // console.log(result.data)

            vm.player_maxhp = result.data.player1_base_hp;
            vm.player_hp = result.data.player1_base_hp;

            vm.opponent_maxhp = result.data.player2_base_hp;
            vm.opponent_hp = result.data.player2_base_hp;

            vm.showHp = true;

            callback(result.data);
          } else {
            vm.line_error = true;
          }
        },
        error: function (error) {
          callback(null);
          // eslint-disable-next-line no-console
          console.error(error);
          vm.line_error = true;
        },
      });
    },
    startShake: function () {
      var vm = this;

      var myShakeEvent = new Shake({
        threshold: 15, // optional shake strength threshold
        timeout: 100, // optional, determines the frequency of event generation
      });

      myShakeEvent.start();
      vm.battlelog = "Start shaking <br>" + vm.battlelog;

      window.addEventListener("shake", this.onShake, false);

      setTimeout(() => {
        myShakeEvent.stop();
        vm.battlelog = "Shake " + vm.count + " times<br>" + vm.battlelog;
        // vm.state = 'fight'
        vm.showCountDown = false;
        // Velocity(vm.$refs.tuinui, 'stop')
        // Velocity(vm.$refs.opponent, 'stop')

        vm.onFighting();
      }, vm.shake_time);
    },
    onFighting: function () {
      var vm = this;
      vm.battlelog = "Let's fight!! <br>" + vm.battlelog;

      vm.calculateBattle(function (data) {
        if (data == null) {
          vm.battlelog = "Something went wrong <br>" + vm.battlelog;
          return false;
        }
        var battlelog_index = 0;
        var battlelog_timer = setInterval(function () {
          // console.log(battlelog_index)
          if (battlelog_index === data.battlelog.length) {
            clearInterval(battlelog_timer);
            vm.onSummaryBattle(data);
          } else {
            //player 1
            if (
              vm.userid + "__148369119115215" ==
              data.battlelog2[battlelog_index].id
            ) {
              if (
                data.battlelog2[battlelog_index].action == "hit" ||
                data.battlelog2[battlelog_index].action == "miss"
              ) {
                vm.damage_opponent =
                  data.battlelog2[battlelog_index].damage > 0
                    ? data.battlelog2[battlelog_index].damage
                    : "Miss";
                vm.tuinuiSmash(
                  vm.$refs.tuinui,
                  "player",
                  battlelog_index,
                  function (index) {
                    vm.opponent_hp =
                      data.battlelog2[index].opponent_hp > 0
                        ? data.battlelog2[index].opponent_hp
                        : 0;
                  }
                );
              } else if (data.battlelog2[battlelog_index].action == "die") {
                clearInterval(battlelog_timer);
                vm.onSummaryBattle(data);
              }
            } else {
              //player 2
              if (
                data.battlelog2[battlelog_index].action == "hit" ||
                data.battlelog2[battlelog_index].action == "miss"
              ) {
                vm.damage_player =
                  data.battlelog2[battlelog_index].damage > 0
                    ? data.battlelog2[battlelog_index].damage
                    : "Miss";
                vm.tuinuiSmash(
                  vm.$refs.opponent,
                  "opponent",
                  battlelog_index,
                  function (index) {
                    vm.player_hp =
                      data.battlelog2[index].opponent_hp > 0
                        ? data.battlelog2[index].opponent_hp
                        : 0;
                  }
                );
              } else if (data.battlelog2[battlelog_index].action == "die") {
                clearInterval(battlelog_timer);
                vm.onSummaryBattle(data);
              }
            }

            vm.battlelog =
              data.battlelog[battlelog_index] + "<br>" + vm.battlelog;
            battlelog_index++;
          }
        }, 1000);
      });
    },
    onShake: function () {
      this.count++;
    },
    onSummaryBattle: function (data) {
      var vm = this;

      vm.battle_result =
        data.winnerid == vm.userid + "__148369119115215"
          ? "player"
          : "opponent";
      Velocity(vm.$refs.tuinui, "stop");
      Velocity(vm.$refs.opponent, "stop");

      Velocity(vm.$refs.tuinui, { translateX: "50px" }, function () {
        vm.isAttack = true;
        if (vm.battle_result == "opponent") {
          setTimeout(() => {
            vm.isAttack = false;
            Velocity(
              vm.$refs.tuinui,
              { translateX: "-500px", rotateZ: "-=360", opacity: 0 },
              { duration: 1000, easing: "linear" }
            );
            setTimeout(() => {
              vm.battlelog = "You are loser <br>" + vm.battlelog;
              (vm.showResult = true),
                setTimeout(() => {
                  vm.showWinner = true;
                  vm.rankDirection = "down";
                  setTimeout(() => {
                    vm.showRank = true;
                    setTimeout(() => {
                      vm.rank += data.gainrank;
                    }, 1000);
                  }, 1000);
                }, 1000);
            }, 2000);
          }, 3000);
        }
      });
      Velocity(vm.$refs.opponent, { translateX: "-50px" }, function () {
        if (vm.battle_result == "player") {
          setTimeout(() => {
            vm.isAttack = false;
            Velocity(
              vm.$refs.opponent,
              { translateX: "500px", rotateZ: "+=360", opacity: 0 },
              { duration: 1000, easing: "linear" }
            );
            setTimeout(() => {
              vm.battlelog = "You are winner <br>" + vm.battlelog;
              (vm.showResult = true),
                setTimeout(() => {
                  vm.showWinner = true;
                  vm.rankDirection = "up";
                  setTimeout(() => {
                    vm.showRank = true;
                    setTimeout(() => {
                      vm.rank += data.gainrank;
                    }, 1000);
                  }, 1000);
                }, 1000);
            }, 2000);
          }, 3000);
        }
      });
      vm.player.current_gamerank = vm.rank;
      vm.player.today_gamerank += 1;
    },
    resetBattle: function () {
      var vm = this;
      vm.step = null;
      vm.battlelog = "";
      vm.showCountDown = false;
      vm.showResult = false;
      vm.battle_result = null;
      vm.count = 0;
      vm.opponent = null;
      vm.state = "welcome";
      vm.showWinner = false;
      vm.showRank = false;
      vm.isBattle = false;
      vm.showHp = false;
    },
    tuinuiSmash: function (el, site, index, callback) {
      var vm = this;
      var num = (site == "player" ? 1 : -1) * 100;
      Velocity.animate(el, { translateX: num + "px" }, { duration: 300 }).then(
        function () {
          if (site == "player") {
            Velocity.animate(
              vm.$refs.attack_by_player,
              { opacity: 1 },
              { duration: 100 }
            ).then(function () {
              Velocity.animate(
                vm.$refs.damage_opponent,
                { opacity: 1 },
                { duration: 100 }
              ).then(function () {
                Velocity.animate(
                  vm.$refs.damage_opponent,
                  { opacity: 0, translateY: "-30px" },
                  { duration: 400 }
                ).then(function () {
                  Velocity.animate(
                    vm.$refs.damage_opponent,
                    { translateY: "0px" },
                    { duration: 0 }
                  );
                });
              });
              Velocity.animate(
                vm.$refs.attack_by_player,
                { opacity: 0 },
                { duration: 200 }
              );
            });
          } else {
            Velocity.animate(
              vm.$refs.attack_by_opponent,
              { opacity: 1 },
              { duration: 100 }
            ).then(function () {
              Velocity.animate(
                vm.$refs.damage_player,
                { opacity: 1 },
                { duration: 100 }
              ).then(function () {
                Velocity.animate(
                  vm.$refs.damage_player,
                  { opacity: 0, translateY: "-30px" },
                  { duration: 400 }
                ).then(function () {
                  Velocity.animate(
                    vm.$refs.damage_player,
                    { translateY: "0px" },
                    { duration: 0 }
                  );
                });
              });
              Velocity.animate(
                vm.$refs.attack_by_opponent,
                { opacity: 0 },
                { duration: 200 }
              );
            });
          }
          Velocity.animate(el, { translateX: "0px" }, { duration: 400 }).then(
            function () {
              callback(index);
            }
          );
        }
      );
    },
  },
  watch: {
    rank: function (newValue) {
      TweenLite.to(this.$data, 0.5, { tweenedRank: newValue });
    },
  },
};
</script>

<style scoped></style>
